import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.result');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-page-result',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.result/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageResultComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public profile: any = null;
    public loading: boolean = true;

    // 피아노 범위 (C2=36 ~ C6=84)
    public pianoLow: number = 36;
    public pianoHigh: number = 84;

    public async ngOnInit() {
        await this.service.init();
        const id = WizRoute.segment.id;
        if (!id) {
            this.service.href('/test');
            return;
        }
        await this.load(id);
    }

    public async load(id: string) {
        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call("get", { id });
        if (code === 200) {
            this.profile = data;
        } else {
            this.service.href('/test');
            return;
        }
        this.loading = false;
        await this.service.render();
    }

    public getReliability(): string {
        if (!this.profile) return '';
        const q = this.profile.quality_score || 0;
        if (q >= 80) return '높음';
        if (q >= 50) return '중간';
        return '낮음';
    }

    public getReliabilityColor(): string {
        if (!this.profile) return '';
        const q = this.profile.quality_score || 0;
        if (q >= 80) return 'text-green-600 bg-green-50';
        if (q >= 50) return 'text-yellow-600 bg-yellow-50';
        return 'text-red-600 bg-red-50';
    }

    public getRangeLeft(): number {
        if (!this.profile) return 0;
        const low = this.profile.lowest_stable_note || 0;
        if (low <= 0) return 0;
        return Math.max(0, ((low - this.pianoLow) / (this.pianoHigh - this.pianoLow)) * 100);
    }

    public getRangeWidth(): number {
        if (!this.profile) return 0;
        const low = this.profile.lowest_stable_note || 0;
        const high = this.profile.highest_stable_note || 0;
        if (low <= 0 || high <= 0) return 0;
        return Math.max(2, ((high - low) / (this.pianoHigh - this.pianoLow)) * 100);
    }

    public getComfortLeft(): number {
        if (!this.profile) return 0;
        const low = this.profile.comfortable_low || 0;
        if (low <= 0) return 0;
        return Math.max(0, ((low - this.pianoLow) / (this.pianoHigh - this.pianoLow)) * 100);
    }

    public getComfortWidth(): number {
        if (!this.profile) return 0;
        const low = this.profile.comfortable_low || 0;
        const high = this.profile.comfortable_high || 0;
        if (low <= 0 || high <= 0) return 0;
        return Math.max(2, ((high - low) / (this.pianoHigh - this.pianoLow)) * 100);
    }

    public getTestModeLabel(): string {
        if (!this.profile) return '';
        const m = this.profile.test_mode;
        if (m === 'measure') return '음역 측정';
        if (m === 'quick') return '빠른 체험';
        if (m === 'guided') return '가이드 테스트';
        return m || '';
    }

    public getVoiceTypeKo(): string {
        const t = this.profile?.voice_type_estimate;
        const map: any = { bass: '베이스', baritone: '바리톤', tenor: '테너', alto: '알토', 'mezzo-soprano': '메조소프라노', soprano: '소프라노' };
        return map[t] || t || '';
    }

    public getRetestReasons(): string[] {
        if (!this.profile) return [];
        const reasons: string[] = [];
        if ((this.profile.environment_score || 0) < 50) reasons.push('주변 소음이 많았습니다');
        if ((this.profile.quality_score || 0) < 50) reasons.push('음정 검출 신뢰도가 낮았습니다');
        return reasons;
    }

    public goRecommend() { this.service.href('/recommend'); }
    public goRetest() { this.service.href('/test/measure'); }
}

export default PageResultComponent;